// extracted by mini-css-extract-plugin
export default {"resizableCell":"ecc7aaHJR1VNwmn4yRna","tableData":"e12T_lIK0uaYRuU9gZRw"};